module.exports = __webpack_public_path__ + "static/img/1.f98fcaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news20/1.png
// module id = jJ7/
// module chunks = 1